import type { EnvConfigType } from "@peerup/host-env"

import { env, envConfig as envConfigOrigin } from "@peerup/host-env"

const {
  location: { host: HOST, hostname },
} = window

/**
 * 是否是本地开发环境，本地开发都是指向请求本地代理，长链非本地开发环境都要明确域名，不能请求当前域名
 */
export const IS_DEV = import.meta.env.DEV || /localhost|\d+\.\d+\.\d+\.\d+/.test(HOST)
// const IS_SSL = PROTOCOL === "https:"

export const WS_PROTOCOL = IS_DEV ? "ws" : "wss" // : "ws"

const DEV_ROOT = "/"

// export const prodRoot = rootMap[EnvType.PROD]
const DEV_CONFIG = {
  ...envConfigOrigin,
  COOKIE_DOMAIN: IS_DEV ? `http://${hostname}` : envConfigOrigin.COOKIE_DOMAIN,
  VITE_APP_DOMAIN_URL: IS_DEV ? DEV_ROOT : `//${HOST}/`,
  VITE_APP_DOMAIN_URL_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_NOTE_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_DOMAIN_HISTORY_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_DOMAIN_URL_XY: IS_DEV ? DEV_ROOT : "//xydev.peerup.com/",
  VITE_APP_LINK_URL: IS_DEV ? DEV_ROOT : `//${HOST}/`,
  NEED_LOG: !IS_DEV,
} as EnvConfigType
export const VITE_ENV = env

/**
 * 当前的环境配置
 */
export const envConfig = IS_DEV ? DEV_CONFIG : envConfigOrigin
